<template>
  <modal name="send-email" adaptive height="auto" @opened="clearForm" @closed="$emit('clearEdit')">
    <Wrapper>
      <template v-slot:header-title>
        <i class="icon--email"></i> {{ $t('fusebox.*') }} {{ $t('fusebox.form.email') }}
      </template>
      <ValidationObserver ref="observer" v-slot="{ invalid }" tag="form" class="form__wrapper">
        <div class="field__row">
          <Field :label="$t('locations.contact')"
                 name="group_name"
                 rules="required|max:255"
                 type="text"
                 v-model="form.name"/>
        </div>
        <div class="field__row">
          <Field :label="$t('fusebox.form.email')"
                 name="email"
                 rules="required|multiple_emails"
                 type="text"
                 :readonly="!!owner"
                 v-model="form.email">
            <template v-if="!owner" v-slot:helper-text>
              {{ $t('fusebox.form.separate_email') }}
            </template>
          </Field>
        </div>
        <div class="field__row">
          <TextareaField :label="$t('fusebox.form.message')"
                         name="message"
                         rules="required"
                         type="text"
                         v-model="form.message">
            <template v-slot:hint>
              <small class="hint">{{ $t('fusebox.form.pay_attention') }}</small>
            </template>

          </TextareaField>
        </div>

        <div class="btn--bar">
          <button type="button" @click="save()" :disabled="invalid" class="btn">
            <i class="icon--email"></i> {{ $t('fusebox.form.sendEmail') }}
          </button>
          <span @click="$emit('hideModal')" class="btn btn--secondary"><i class="icon--cancel"></i> {{
            $t('general.close') }}
          </span>
        </div>

      </ValidationObserver>
    </Wrapper>
  </modal>
</template>

<script>
import Field from '@/components/Parts/Field'
import TextareaField from '@/components/Parts/Textarea'
import Wrapper from '@/components/Modal/Wrapper'
import { errHandler } from '@/helpers'

export default {
  name: 'Modal-Fusebox-Email',
  props: {
    preEmailBody: {
      type: String,
      default: ''
    },
    owner: {
      type: [String, Boolean],
      default: false
    }
  },
  components: {
    Wrapper,
    Field,
    TextareaField
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  computed: {
    modifiedForm () {
      const newForm = {
        ...this.form,
        id: this.$route.params.id
      }
      newForm.email = newForm.email.split(',').map(mail => mail.trim().toLowerCase())
      return newForm
    }
  },
  methods: {
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          await this.$store.dispatch('fusebox/sendEmail', this.modifiedForm)
          this.$emit('hideModal')
          this.$toasted.global.success_message({
            message: this.$t('fusebox.successfully_sent')
          })
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        }
      }
    },
    clearForm () {
      this.$nextTick(() => {
        this.form = {
          name: '',
          email: this.owner === false ? '' : this.owner,
          message: this.preEmailBody === false ? '' : this.preEmailBody
        }

        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      })
    }
  }
}
</script>
